import React from 'react';
import EnvironmentProvider from '../../contexts/EnvironmentContext';
import { useGATrackingForSSR } from '../../utils/gaTracking';
import { AutosFeeds } from './components/AutosFeeds/AutosFeeds';
import { ConfiguredToastContainer } from '@hz-design-system/web-ui';

const AutospageApp = ({ environment }) => {
  useGATrackingForSSR();

  return (
    <EnvironmentProvider value={environment}>
      <ConfiguredToastContainer />
      <AutosFeeds />
    </EnvironmentProvider>
  );
};

export default AutospageApp;
